import { call, put, takeLatest } from 'redux-saga/effects';

import { SET_SUBTITLE_ACTION } from 'src/redux/data/actions';
import { setSubtitleValSuccess } from 'src/redux/data/actions';
import { apiCallAsync } from 'src/redux/sagas';
import { EDIT_CUSTOM_SUBTITLE } from 'src/redux/view/constants';
import { getActionAPISource, showNotification } from 'src/utils';
import { SetSubtitleValRequestAction } from '../types';

export function* SubtitleApiCallSaga(action: SetSubtitleValRequestAction) {
  try {
    const url = getActionAPISource(EDIT_CUSTOM_SUBTITLE);

    const params = {
      section_id: action.sectionId,
      custom_subtitle: action.value,
    };

    const response = yield call(apiCallAsync, url, params, 'post');

    if (response.status >= 200 && response.status < 300) {
      yield put(
        setSubtitleValSuccess({
          value: response.data.new_custom_subtitle,
        }),
      );
    } else {
      throw 'Set Subtitle API call has failed';
    }
  } catch (e) {
    showNotification(e.message || 'Error', 'error');
    console.error(e);
  }
}

export default function* setSubtitleSaga() {
  yield takeLatest(SET_SUBTITLE_ACTION, SubtitleApiCallSaga);
}
